import React from "react";
import { Disc3 } from "lucide-react";

/**
 * Vinyl Icon Badge für Label Manager.
 * Zeigt einen dunkelgrünen Vinyl-Disc Icon als Rolle-Indikator.
 */
export function LabelManagerBadge({ size = 14, className = "", title = "Label Manager" }) {
  return (
    <span
      title={title}
      className={`inline-flex items-center justify-center rounded-full flex-shrink-0 ${className}`}
      style={{
        width:   size + 4,
        height:  size + 4,
        background: "rgba(16, 185, 129, 0.12)",
        border:  "1px solid rgba(16, 185, 129, 0.3)",
        color:   "#10b981",
      }}
    >
      <Disc3 size={size - 2} />
    </span>
  );
}
